import { Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef, OnChanges, SimpleChanges } from '@angular/core';
import { Align } from '@progress/kendo-angular-popup';

@Component({
  selector: 'app-add-to-watchlist',
  templateUrl: './add-to-watchlist.component.html',
  styleUrls: ['./add-to-watchlist.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddToWatchlistComponent implements OnInit, OnChanges {
  @Input() selectedCompany;
  @Input() darkMode;
  public popupAlign: Align = { horizontal: 'right', vertical: 'top' };
  public anchorAlign: Align = { horizontal: 'right', vertical: 'bottom' };
  show = false;
  stockCode = null;
  loadingList = false;
  selectedAsWatchList = null;
  masterStockList = null;
  constructor(private cdRef: ChangeDetectorRef) {}

  async ngOnInit() {}

  async ngOnChanges(changes: SimpleChanges) {
    if (!!changes['selectedCompany']) {
      this.selectedAsWatchList = null;
      this.stockCode = null;
      this.stockCode = this.selectedCompany?.companyName;
      if (this.stockCode) {
        await this.loadingWatchList();
      }
    }
  }
  checkStockCode() {
    let selected = this.masterStockList.find((s) => s.stockData.companyName === this.stockCode);
    if (selected) {
      this.selectedAsWatchList = selected;
    }
    this.cdRef.detectChanges();
  }

  async loadingWatchList() {
    try {
      this.loadingList = true;
      this.loadingList = false;
      this.cdRef.detectChanges();
    } catch (e) {}
  }

  savetoWatchList = () => {
    // alert(this.selectedCompany);
  };

  async addToWatchList() {
    try {
      // let  data = await this.product.addToWatchList(this.stockCode);
      this.show = false;
      // this.selectedAsWatchList = data;
      this.cdRef.detectChanges();
    } catch (e) {
      console.log(e);
    }
  }

  async removeItemFromWatchList(id) {
    try {
      // await this.product.deleteWatchListItem(id);
      this.show = false;
      this.selectedAsWatchList = null;
      this.cdRef.detectChanges();
    } catch (e) {
      console.log(e);
    }
  }
}
